/**
 * Formats the list of accepted file extensions for display
 *
 * @param acceptedExtensions Array of file extensions (e.g. ['.csv', '.xlsx'])
 * @returns Formatted string (e.g. "CSV, XLSX" or "CSV or XLSX")
 */
export const formatAcceptedExtensions = (
  acceptedExtensions: string[]
): string => {
  const upperCaseExtensions = acceptedExtensions.map((ext) =>
    ext.toUpperCase().replace(".", "")
  );

  if (upperCaseExtensions.length === 0) {
    return "";
  }

  if (upperCaseExtensions.length === 1) {
    return upperCaseExtensions[0];
  }

  if (upperCaseExtensions.length === 2) {
    return `${upperCaseExtensions[0]} or ${upperCaseExtensions[1]}`;
  }

  const lastExt = upperCaseExtensions.pop();
  return `${upperCaseExtensions.join(", ")}, or ${lastExt}`;
};

/**
 * Validates if a file has one of the accepted extensions
 *
 * @param file File to validate
 * @param acceptedExtensions Array of accepted file extensions
 * @returns true if the file has an accepted extension, false otherwise
 */
export const validateFileExtension = (
  file: File,
  acceptedExtensions: string[]
): boolean => {
  for (const extension of acceptedExtensions) {
    if (file.name.toLowerCase().endsWith(extension.toLowerCase())) {
      return true;
    }
  }
  return false;
};
